import { TOGGLE_THEME } from '../constants'

export const dispatchToggleTheme = () => ({ type: TOGGLE_THEME })